import { ToastContainer } from './ToastContainer';
import { ToasterStoreContext } from './ToasterStoreContext';
import { useContext, useEffect, useState, createElement as _createElement } from 'react';
import { useMediaQuery } from '@mui/material';
import { useInterstateTheme } from '../../InterstateThemeProvider';
import { ToastProxy } from './ToastProxy';
import { TOAST_TIMEOUT } from './store';
import { Box } from '../../Box';
import { jsx as _jsx } from "react/jsx-runtime";
const styledToastContainer = _ref => {
  let {
    position
  } = _ref;
  return {
    position: 'fixed',
    zIndex: '999999',
    display: 'flex',
    justifyContent: 'flex-start',
    alignContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
    top: '16px',
    ...(position === 'top-right' ? {
      right: '16px'
    } : {
      left: '50%',
      transform: 'translateX(-50%)'
    }),
    width: '320px',
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale'
  };
};
/**
 * Represents a viewport for displaying toasts.
 * @param {ToasterViewPortProps} props - The props for the ToasterViewPort component.
 * @returns {JSX.Element} - The rendered component.
 */
export const ToasterViewPort = props => {
  const context = useContext(ToasterStoreContext);
  const theme = useInterstateTheme();
  const {
    containerId
  } = props;
  const [_toasts, setToasts] = useState([]);
  const [_maxToasts, setMaxToasts] = useState(3);
  const [_position, setPosition] = useState('top-right');
  useEffect(() => {
    if (context?.toastStore) {
      const containerMap = context.toastStore.get(containerId);
      if (containerMap) {
        setToasts(Array.from(containerMap.values()));
      }
    }
  }, [context, containerId]);
  const smallView = useMediaQuery(theme.breakpoints.down('sm'));
  useEffect(() => {
    setMaxToasts(smallView ? 1 : 3);
    setPosition(smallView ? 'top-center' : 'top-right');
  }, [smallView]);

  // sort the toasts in reverse chronological order by timestamp
  const sortedToasts = _toasts?.sort((a, b) => b.timeStamp - a.timeStamp);

  // create the toasts to display
  const toastList = sortedToasts ? sortedToasts.map((t, index) => {
    if (Date.now() > t.timeStamp + TOAST_TIMEOUT) {
      return null;
    }
    return t.useParentContainer ? /*#__PURE__*/_createElement(ToastProxy, {
      ...t,
      key: t.toastId,
      maxToasts: _maxToasts,
      index: index,
      totalToasts: sortedToasts.length
    }) : /*#__PURE__*/_createElement(ToastContainer, {
      ...t,
      key: t.toastId,
      maxToasts: _maxToasts,
      index: index,
      totalToasts: sortedToasts.length
    });
  }).filter(Boolean) : null;
  return /*#__PURE__*/_jsx(Box, {
    sx: styledToastContainer({
      position: _position
    }),
    className: 'ids-toaster-viewport',
    id: 'ids-toaster-viewport',
    children: toastList
  });
};